const trueValues: string[] = ['true', '1'];

export const isTrueValue = (value: any): boolean =>
  typeof value === 'string'
    ? trueValues.includes(value.toLowerCase())
    : typeof value === 'number'
      ? value === 1
      : !!value;

